import React from 'react'

import Base from '../_Base'

const History = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C9.535,22 7.167,21.096 5.333,19.453 C4.921,19.085 4.886,18.452 5.254,18.041 C5.623,17.629 6.255,17.594 6.667,17.963 C8.134,19.276 10.028,20 12,20 C16.411,20 20,16.411 20,12 C20,7.589 16.411,4 12,4 C7.928,4 4.564,7.06 4.069,11 L4.069,11 L6,11 L3,14 L0,11 L2.051,11 C2.554,5.954 6.823,2 12,2 Z M12,6 C12.5522847,6 13,6.44771525 13,7 L13,12.4114975 L9.70710678,15.7043907 C9.31658249,16.094915 8.68341751,16.094915 8.29289322,15.7043907 C7.90236893,15.3138664 7.90236893,14.6807014 8.29289322,14.2901772 L11,11.5830704 L11,7 C11,6.44771525 11.4477153,6 12,6 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default History
